/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Hotel_Lobby_Motion_Video_UrlInputs */

const en_admin_settings_fields_hotel_lobby_motion_video_url = /** @type {(inputs: Admin_Settings_Fields_Hotel_Lobby_Motion_Video_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legacy Fal reference video URL`)
};

/**
* | output |
* | --- |
* | "Legacy Fal reference video URL" |
*
* @param {Admin_Settings_Fields_Hotel_Lobby_Motion_Video_UrlInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_hotel_lobby_motion_video_url = /** @type {((inputs?: Admin_Settings_Fields_Hotel_Lobby_Motion_Video_UrlInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Hotel_Lobby_Motion_Video_UrlInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_hotel_lobby_motion_video_url(inputs)
});
export { admin_settings_fields_hotel_lobby_motion_video_url as "admin.settings.fields.hotel_lobby_motion_video_url" }